// extracted by mini-css-extract-plugin
module.exports = {"logo":"Header_logo__3_SJs","reactLogo":"Header_reactLogo__22_I9"};